import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ConfirmModal } from 'common/components';

type Props = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const ConfirmationModal = ({ open, onCancel, onConfirm }: Props) => {
  return (
    <ConfirmModal
      open={open}
      header={<FormattedMessage id="dropdown.areYouSure" />}
      description={<FormattedMessage id="shared-menu.editor.image-gallery.confirm-discard-changes-info" />}
      cancelText={<FormattedMessage id="state.cancel" />}
      confirmText={<FormattedMessage id="state.confirm" />}
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};
